import SupremeThirumeni from "../assets/media/officebearers/supremethirumeni.png";
import Thirumeni from "../assets/media/officebearers/thirumeni.jpg";
import TijiThankachan from "../assets/media/officebearers/tijithankachan.png";
import HappyJacob from "../assets/media/officebearers/happyjacob.png";
import SabuKadavanthanam from "../assets/media/officebearers/sabukadavanthanam6.png";
import MohanGeorge from "../assets/media/officebearers/mohangeorge.png";
import BijiVarughese from "../assets/media/officebearers/bijivarughese.png";
import RiyaBaiju from "../assets/media/officebearers/riyabaiju.png";
import NadiyaIype from "../assets/media/officebearers/nadiyaiype.png";
import SusanThomas from "../assets/media/officebearers/susanthomas.png";
import JinuGeorge from "../assets/media/officebearers/jinugeorge.png";
import SheenaBiji from "../assets/media/officebearers/sheenabiji.png";
import RincyXavier from "../assets/media/officebearers/rincyxavier.png";
import JinsuGeorge from "../assets/media/officebearers/jinsugeorge.png";
import RinoshKoshy from "../assets/media/officebearers/rinoshkoshy.png";
import LinuAbraham from "../assets/media/officebearers/linuabraham.png";
import DellaSabu from "../assets/media/officebearers/dellasabu.png";
import TibinMathew from "../assets/media/officebearers/tibinmathew.png";
import AllanMathew from "../assets/media/officebearers/allanmathew.png";
import LijoMathew from "../assets/media/officebearers/lijomathew.png";
import AshnaSaji from "../assets/media/officebearers/ashnasaji.png";
import PlaceHolder from "../assets/media/officebearers/placeholder.png";


export const metropolitans = [
  {
    title: (
      <>
        Catholicos of East &<br /> Malankara Metropolitan
      </>
    ),
    name: "H.H. Baselios Marthoma Mathews III",
    href: "https://mosc.in/holysynod/his-holiness-baselios-marthoma-mathews-iii",
    image: SupremeThirumeni,
  },
  {
    title: (
      <>
        Diocesan Metropolitan of <br />
        UK, Europe & Africa
      </>
    ),
    name: "H. G. Abraham Mar Stephanos",
    href: "https://mosc.in/holysynod/h-g-abraham-mar-stephanos-metropolitan",
    image: Thirumeni,
  },
];

export const officebearers = [
  {
    title: "Vicar",
    name: "Rev. Fr. Tiji Thankachan",
    image: TijiThankachan,
  },
  {
    title: "Trustee",
    name: "Sabu Kadavanthanam",
    image: SabuKadavanthanam,
  },
  {
    title: "Secretary",
    name: "Susannamma Thomas",
    image: SusanThomas,
  },
  {
    title: "Committee Member",
    name: "Biji Varughese",
    image: BijiVarughese,
  },
  {
    title: "Committee Member",
    name: "Jinsu George",
    image: JinsuGeorge,
  },
  {
    title: "Committee Member",
    name: "Rinosh Koshy",
    image: RinoshKoshy,
  },
  {
    title: "Committee Member",
    name: "Tibin Mathew",
    image: TibinMathew,
  },
  {
    title: "Committee Member & Safeguarding Officer",
    name: "Jinu George",
    image: JinuGeorge,
  },
  {
    title: "Internal Auditor",
    name: "Nadiya Iype",
    image: NadiyaIype,
  },
  {
    title: "Social Media Coordinator",
    name: "Della Sabu",
    image: DellaSabu,
  },
  
];

export const spiritual_organisers = [
  {
    title: "AMOSS Secretary",
    name: "Lijo Mathew",
    image: LijoMathew,
  },
  {
    title: "MMVS Secretary",
    name: "Sheena Philips",
    image: SheenaBiji,
  },
  {
    title: "Asst. MMVS Secretary",
    name: "Linu Abraham",
    image: LinuAbraham,
  },
  {
    title: "Sunday School Head Teacher",
    name: "Riyamol Rajan",
    image: RiyaBaiju,
  },
  {
    title: "Asst. Sunday School Head Teacher",
    name: "Rincy Xavier",
    image: RincyXavier,
  },
  {
    title: "Asst. Sunday School Head Teacher",
    name: "Jinsu George",
    image: JinsuGeorge,
  },
  {
    title: "Youth Coordinator",
    name: "Allan Mathew",
    image: AllanMathew,
  },
  {
    title: "Asst. Youth Coordinator",
    name: "Ashna Saji",
    image: AshnaSaji,
  },
];

export const msca = [
  {
    title: "MSCA Representative",
    name: "Rev. Fr. Happy Jacob",
    href: "https://mosc.in/administration/malankara-association",
    image: HappyJacob,
  },
  {
    title: "MSCA Representative",
    name: "Sabu Kadavanthanam",
    href: "https://mosc.in/administration/malankara-association",
    image: SabuKadavanthanam,
  },
];

export const msca_diocese = [
  {
    title: "Diocese of UK, Europe & Africa Representative",
    name: "Dr. Mohan George",
    href: "https://mosc.in/administration/malankara-association",
    image: MohanGeorge,
  },
];
